// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__3yaSH","minWidth":"grid_minWidth__1YZ9N","relat":"grid_relat__hGNpl","title":"grid_title__1oE0E","hover":"grid_hover__2YImF"};